document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparadorTabs();
  initGaleriaProducto();
  initVariantes();
  initFaqAcordeon();
  initContador();
});

function initReveal() {
  var els = document.querySelectorAll('.od-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('od-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('od-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initComparadorTabs() {
  document.querySelectorAll('[data-od-comparador]').forEach(function (wrap) {
    var btns = wrap.querySelectorAll('[data-od-tab]');
    var panels = wrap.querySelectorAll('[data-od-panel]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-od-tab');
        btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-od-panel') === target);
        });
      });
    });
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-od-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-od-imagen-principal]');
    var dataEl = galeria.querySelector('[data-od-galeria-json]');
    var prevBtn = galeria.querySelector('[data-od-galeria-prev]');
    var nextBtn = galeria.querySelector('[data-od-galeria-next]');
    if (!principal || !dataEl || !prevBtn || !nextBtn) return;
    var fotos;
    try { fotos = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(fotos) || fotos.length < 2) return;

    var indice = Math.max(0, fotos.indexOf(principal.getAttribute('src')));

    function mostrar(nuevoIndice) {
      indice = (nuevoIndice + fotos.length) % fotos.length;
      principal.src = fotos[indice];
    }

    prevBtn.addEventListener('click', function () { mostrar(indice - 1); });
    nextBtn.addEventListener('click', function () { mostrar(indice + 1); });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-od-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-od-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var scope = form.closest('.od-producto') || form;
    var selects = form.querySelectorAll('[data-od-opcion]');
    var idInput = form.querySelector('[data-od-variant-id]');
    var precioEl = scope.querySelector('[data-od-precio]');
    var precioCompareEl = scope.querySelector('[data-od-precio-compare]');
    var botonEl = form.querySelector('[data-od-add-boton]');
    var imagenPrincipalEl = scope.querySelector('[data-od-imagen-principal]');
    var miniVarianteEl = scope.querySelector('[data-od-mini-variante]');
    var stockEl = scope.querySelector('[data-od-stock-bajo]');
    var stockCantidadEl = scope.querySelector('[data-od-stock-cantidad]');
    var umbralStock = parseInt(form.getAttribute('data-od-umbral-stock'), 10) || 0;

    function moneyFormat(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function actualizar() {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = moneyFormat(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneyFormat(variante.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (variante.available) {
          botonEl.disabled = false;
          botonEl.textContent = botonEl.getAttribute('data-texto-disponible') || 'Añadir al carrito';
        } else {
          botonEl.disabled = true;
          botonEl.textContent = botonEl.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
      if (stockEl) {
        var mostrarStock = variante.inventory_tracked && variante.inventory_quantity > 0 && variante.inventory_quantity <= umbralStock;
        stockEl.style.display = mostrarStock ? '' : 'none';
        if (mostrarStock && stockCantidadEl) stockCantidadEl.textContent = variante.inventory_quantity;
      }
      if (imagenPrincipalEl && variante.image) {
        imagenPrincipalEl.src = variante.image;
      }
      if (miniVarianteEl) {
        miniVarianteEl.innerHTML = '';
        var fotos = [variante.image, variante.image2].filter(Boolean);
        if (fotos.length > 1) {
          fotos.forEach(function (src, i) {
            var btn = document.createElement('button');
            btn.type = 'button';
            if (i === 0) btn.className = 'is-active';
            var img = document.createElement('img');
            img.src = src;
            img.loading = 'lazy';
            img.alt = '';
            btn.appendChild(img);
            btn.addEventListener('click', function () {
              if (imagenPrincipalEl) imagenPrincipalEl.src = src;
              miniVarianteEl.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
            });
            miniVarianteEl.appendChild(btn);
          });
        }
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', actualizar);
    });
    actualizar();
  });
}

function initFaqAcordeon() {
  document.querySelectorAll('[data-od-faq-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-od-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierta = item.classList.contains('is-open');
      item.closest('[data-od-faq]').querySelectorAll('[data-od-faq-item]').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!abierta) item.classList.add('is-open');
    });
  });
}

function initContador() {
  document.querySelectorAll('[data-od-contador]').forEach(function (el) {
    var fin = parseInt(el.getAttribute('data-od-contador'), 10);
    if (isNaN(fin)) return;
    var animado = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !animado) {
          animado = true;
          var inicio = 0;
          var duracion = 1400;
          var t0 = performance.now();
          function paso(t) {
            var progreso = Math.min((t - t0) / duracion, 1);
            var valor = Math.floor(inicio + (fin - inicio) * (1 - Math.pow(1 - progreso, 3)));
            el.textContent = valor;
            if (progreso < 1) requestAnimationFrame(paso);
            else el.textContent = fin;
          }
          requestAnimationFrame(paso);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    observer.observe(el);
  });
}
